const MOUNT_OPTIONS = {
  LANGUAGE: {
    ENGLISH: 'english',
    SPANISH: 'spanish'
  }
}

export { MOUNT_OPTIONS }